import { gql } from 'apollo-angular';

export const ORGANIZATION_BASE_FRAGMENT = gql`
  fragment OrganizationBaseFragment on Organization {
    id
    name
    missingInSource
  }
`;
